import { Component } from '@angular/core';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ShareGroupView } from "@pages/shares/models/share-group-view";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CorporateHolderModel, IndividualHolderModel } from "@models/shares/security-registry-record";

type CellRendererParams = ICellRendererParams<ShareGroupView, (IndividualHolderModel | CorporateHolderModel)[]>;

@Component({
  selector: 'app-ag-share-holder',
  standalone: true,
  imports: [NgbTooltip],
  templateUrl: 'ag-share-holder.component.html',
  styleUrl: 'ag-share-holder.component.scss'
})
export class AgShareHolderComponent implements ICellRendererAngularComp {
  holders: (IndividualHolderModel | CorporateHolderModel)[] = [];
  nonAsic = false;
  hasIssue = false;
  hasWarning = false;
  issueMessage= '';

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    if (params.value !== null && params.value !== undefined) {
      this.holders = [params.value].flat();
    }

    this.nonAsic = params.data?.nonAsic ?? false;
    this.hasIssue = params.data?.hasIssue ?? false;
    this.hasWarning = params.data?.hasWarning ?? false;
    this.issueMessage = params.data?.issueMessage ?? '';

    return true;
  }
}
